import React from 'react';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import ControlButton from '../ControlButton/ControlButton';
import type { Controls } from '../../../useControls';

const NavigationControl = ({ controls }: { controls: Controls }) => (
	<ControlButton
		actions={[
			{ id: 'zoom-in', label: 'Zoom in', icon: <AddIcon />, onClick: controls.zoomIn, dataCy: 'zoom-in' },
			{ id: 'zoom-out', label: 'Zoom out', icon: <RemoveIcon />, onClick: controls.zoomOut, dataCy: 'zoom-out' },
		]}
	/>
);

export default NavigationControl;
